import styled from "styled-components";

export const StyledOnboardingModalContentWrapper = styled.div`
    display: flex;
    position: relative;
    flex-grow: 1;
    height: 100%;
`;
